<template>
<SideComponent @scrollto="scroll"></SideComponent>
	<div class="container" ref="viewBox">
		<Header2 :show-search-bar-pic="showHeader" login-style="loginStyle" :mobile-icon-style="mobileIconStyle" :show-list-icon="showListIcon"/>
		<div class="content">
			<div style="height:80px;"></div>
			<div class="enclosure">
				<div class="inner">
					<div class="left">
						<SideMenu />
					</div>
					<div class="right">
						<div class="caption">
							<span>{{$t('person.personCenter')}}</span><span class="arrow"><i class="iconfont icon-jiantou2"></i></span><span>{{$t('sideMenu.apply')}}</span>
						</div>
						
						<div class="tag-outer">
							<div class="tag-item">
								<img src="@/assets/img/grapher_settled/pass.png"/>
							</div>
							<div class="tag-item">
								<span class="text-1">{{$t('apply_pass.tip1')}}</span>
							</div>
							<div class="tag-item">
								<span class="text-2">{{$t('apply_pass.tip2')}}</span>
							</div>
							<div class="tag-item">
								<div class="settled-btn" @click="toContract()">{{$t('apply_pass.tip3')}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
	import apply_pass from './apply_pass_controller';
	export default apply_pass;
</script>

<style src="@/assets/css/my/grapher/apply_pass.css" scoped></style>